import { motion, AnimatePresence } from "framer-motion";
import Confetti from "./Confetti";
import Mascot from "./Mascot";

export default function CelebrationModal({
  open, onClose, title, subtitle,
  emoji, mascotState = "celebrating", customVisual = null,
  confetti = true, cta = "Awesome!", testid = "celebration-modal",
}) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center px-6"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          data-testid={testid}
        >
          <div className="absolute inset-0 bg-[hsl(var(--ink))]/40 backdrop-blur-sm" onClick={onClose} />
          {confetti && <Confetti show={open} count={90} />}
          <motion.div
            initial={{ scale: 0.7, y: 40 }} animate={{ scale: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 240, damping: 16 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative surface w-full max-w-sm px-6 py-8 text-center z-10"
          >
            {customVisual ? (
              <div className="flex justify-center -mt-4 mb-1 animate-bob">{customVisual}</div>
            ) : emoji ? (
              <div className="text-7xl mb-2 animate-bob" aria-hidden>{emoji}</div>
            ) : (
              <div className="flex justify-center -mt-4 mb-1">
                <Mascot state={mascotState} size={140} testId="celebration-mascot"/>
              </div>
            )}
            <h2 className="text-3xl text-[hsl(var(--ink))]">{title}</h2>
            {subtitle && <p className="mt-2 text-[hsl(var(--ink-soft))] text-base">{subtitle}</p>}
            <button
              data-testid="celebration-dismiss-btn"
              onClick={onClose}
              className="btn btn-primary mt-6 w-full"
            >
              {cta}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
